<template>
    <div class="wrap td-fcc td-fc">
        <div class="logo-box">
            <img class="logo" :src="GLOBAL.Images.logo" alt="">
        </div>
        <div class="login-box">
            <div class="login-title td-fcc">
                <div class="cycle-box td-fcc">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <span class="title">注册</span>
            </div>
            <div class="input-box">
                <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form">
                    <template v-for="(item, index) in formField">
                                <div
                                    class="verify-box"
                                    v-if="item.field == 'img_code'"
                                    :key="index"
                                >
                                    <el-form-item :prop="item.field">
                                        <el-input
                                            v-model="loginForm[item.field]"
                                            :placeholder="item.desc"
                                            :prefix-icon="item.icon"
                                            :type="item.form_type"
                                        ></el-input>
                                    </el-form-item>
                                    <div
                                        class="verify-code"
                                        @click="refreshCode"
                                    >
                                        <s-identify :identifyCode="identifyCode"></s-identify>
                                    </div>
                                </div>
                                <div
                                    class="verify-box"
                                    v-else-if="item.field == 'sms_code'"
                                    :key="index"
                                >
                                    <el-form-item :prop="item.field">
                                        <el-input
                                            v-model="loginForm[item.field]"
                                            :placeholder="item.desc"
                                            :prefix-icon="item.icon"
                                            :type="item.form_type"
                                        ></el-input>
                                    </el-form-item>
                                    <div
                                        class="verify-code"
                                        @click="getMobildCode"
                                    >
                                        <div
                                            class="sms-code-btn td-fcc"
                                            :class="{'disabled': timeOut !== 60}"
                                        >
                                            {{sms_code_text}}
                                        </div>
                                    </div>
                                </div>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :prop="item.field"
                                >
                                    <el-input
                                        v-model="loginForm[item.field]"
                                        :placeholder="item.desc"
                                        :prefix-icon="item.icon"
                                        :type="item.form_type"
                                    ></el-input>
                                </el-form-item>
                    </template>

                    <el-form-item>
                        <div class="button-box">
                            <el-button
                                class="submit-btn"
                                type="success"
                                @click="submitForm('loginForm')"
                            >立即注册
                            </el-button>
                            <el-button
                                class="inquiry-btn"
                                type="danger"
                                @click="resetForm('loginForm')"
                            >重置
                            </el-button>
                        </div>
                    </el-form-item>
                    <div class="tips td-fbc">
                        <span
                            class="to-register"
                            @click="$router.go(-1)"
                        >去登录</span>
                        <span @click="$router.replace('/')">返回首页</span>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="login-bottom-img td-fes">
            <img src="@/assets/img/login_bg_2.png" alt="">
        </div>
    </div>
</template>

<script>
import Lockr from "lockr";
import SIdentify from "@/components/Identify";
import { register } from "@/api/login";
import { getCode } from "@/api/common";

export default {
    name: "index",
    components: {
        SIdentify
    },
    data() {
        // 验证码验证规则
        var validateCode = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入验证码"));
            } else {
                if (value !== this.identifyCode) {
                    callback(new Error("验证码错误"));
                }
                callback();
            }
        };
        var validateRepassword = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入确认密码"));
            } else {
                if (value !== this.loginForm.password) {
                    callback(new Error("两次输入密码不一致，请重新输入"));
                }
                callback();
            }
        };
        return {
            identifyCode: "",
            loginForm: {
                emp_no: "",
                password: "",
                password_confirm: "",
                mobile: "",
                img_code: "",
                sms_code: ""
            },
            formField: [{
                    label: "用户",
                    field: "emp_no",
                    form_type: "text",
                    icon: "el-icon-user",
                    desc: "请输入登录账号"
                },
                {
                    label: "密码",
                    field: "password",
                    form_type: "password",
                    icon: "el-icon-lock",
                    desc: "请输入登录密码"
                },
                {
                    label: "确认密码",
                    field: "password_confirm",
                    form_type: "password",
                    icon: "el-icon-lock",
                    desc: "请再次输入登录密码"
                },
                {
                    label: "手机号",
                    field: "mobile",
                    form_type: "tel",
                    icon: "el-icon-mobile",
                    desc: "请输入手机号"
                },
                {
                    label: "验证码",
                    field: "img_code",
                    form_type: "text",
                    icon: "el-icon-picture",
                    desc: "请输入图形验证码"
                },
                {
                    label: "短信验证码",
                    field: "sms_code",
                    form_type: "text",
                    icon: "el-icon-message",
                    desc: "请输入短信验证码"
                }
            ],
            loginRules: {
                emp_no: [{
                    required: true,
                    message: "请输入登录账号",
                    trigger: "blur"
                }],
                password: [{
                    required: true,
                    message: "请输入密码",
                    trigger: "blur"
                }],
                password_confirm: [
                    { validator: validateRepassword, trigger: "blur" }
                ],
                mobile: [{
                        required: true,
                        message: "请输入登录密码",
                        trigger: "blur"
                    },
                    {
                        min: 11,
                        max: 11,
                        message: "请输入正确的手机号",
                        trigger: "blur"
                    }
                ],
                img_code: [{ validator: validateCode, trigger: "blur" }],
                sms_code: [{
                    required: true,
                    message: "请输入登录密码",
                    trigger: "blur"
                }]
            },
            sms_code_text: "获取短信验证码",
            timeOut: 60
        };
    },
    methods: {
        // 更新验证码
        refreshCode() {
            this.identifyCode = Math.random()
                .toString(36)
                .substr(2)
                .slice(1, 5);
            // this.loginForm.img_code = this.identifyCode;
        },
        // 表单重置
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 表单提交
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.requestForm();
                }
            });
        },
        async requestForm() {
            let { img_code, sms_code, ...params } = this.loginForm;
            params.code = sms_code;
            let result = await register(params);
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.$message.success({
                    message: "注册成功",
                    duration: "2000",
                    onClose: () => {
                        this.$router.go(-1);
                    }
                });
            } else {
                this.$message.warning({
                    message: result.msg,
                    duration: "2000"
                });
                this.refreshCode();
            }
        },
        // sms_code_text
        async getMobildCode() {
            if (this.timeOut !== 60) return null;
            if (!this.loginForm.mobile) {
                this.$message.warning({
                    message: "请输入手机号",
                    duration: "2000"
                });
                return null;
            }
            if (!this.loginForm.img_code) {
                this.$message.warning({
                    message: "请输入图片验证码",
                    duration: "2000"
                });
                return null;
            }
            if (this.loginForm.img_code != this.identifyCode) {
                this.$message.warning({
                    message: "验证码错误",
                    duration: "2000"
                });
                this.refreshCode();
                return null;
            }
            let params = {
                mobile: this.loginForm.mobile
            };
            let result = await getCode(params);
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.$message.success({
                    message: "短信验证码已发送成功，请注意查收",
                    duration: "2000"
                });
                var t = setInterval(() => {
                    if (this.timeOut > 1) {
                        this.timeOut--;
                        this.sms_code_text = `${this.timeOut}秒后重试`;
                    } else {
                        this.timeOut = 60;
                        clearInterval(t);
                        this.sms_code_text = "获取验证码";
                    }
                }, 1000);
            } else {
                this.$message.warning({
                    message: result.msg,
                    duration: "2000"
                });
            }
        }
    },
    created() {
        this.refreshCode();
    }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/form";
.wrap {
    background: #dcebff;
    background: url("../../assets/img/maoboli.png");
    background-size: cover;
    background-position: right bottom;
    background-repeat: no-repeat;
    min-height: 100vh;
    padding-top: 40px;
}

.logo-box {
    margin-bottom: 30px;
    img {
        display: block;
        height: 72px;
    }
}

.login-box {
    width: 560px;
    padding-bottom: 20px;
    border-radius: 15px;
    background: #fff;
    overflow: hidden;
    .input-box {
        width: 370px;
        margin: 40px auto;
        .input-title {
            font-size: 24px;
            text-align: center;
            line-height: 100px;
        }
    }
    .hint {
        text-align: center;
        color: #fa4860;
        font-size: 16px;
        margin: 30px auto;
        width: 370px;
        span {
            width: 100%;
            box-sizing: border-box;
            display: inline-block;
            border-radius: 5px;
            padding: 10px 20px;
            background-color: #f3f3f3;
        }
    }
    .tips {
        font-size: 12px;
        color: #666;
        span {
            cursor: pointer;
        }
        .to-register {
            color: #00bfcc;
        }
    }
    .button-box {
        display: flex;
        .submit-btn {
            flex: 1;
        }
        .inquiry-btn {
            width: 145px;
        }
    }
}

.login-title {
    position: relative;
    height: 50px;
    background-color: #25c6c7;
    .title {
        font-size: 16px;
        color: #fff;
    }
    .cycle-box {
        position: absolute;
        top: 0;
        left: 10px;
        height: 100%;
        span {
            display: block;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            margin: 0 5px;
        }
        >span:nth-child(1) {
            background-color: #ff8493;
        }
        >span:nth-child(2) {
            background-color: #f8d44f;
        }
        >span:nth-child(3) {
            background-color: #7ed321;
        }
    }
}

.login-form {
    .verify-box {
        align-items: flex-end;
    }
}

// sms-code-btn
.sms-code-btn {
    height: 40px;
    font-size: 14px;
    background-color: #00bfcc;
    cursor: pointer;
}

.sms-code-btn.disabled {
    background-color: #eee;
}

.login-bottom-img {
    margin-top: -30px;
    width: 560px;
    img {
        width: 140px;
        display: block;
    }
}

@media (max-width: 768px) {
    .login-bottom-img {
        width: 100%;
        display: none;
    }
}
</style>